import type { MapLocation } from '../S32MapView/Map/Map';

// https://stackoverflow.com/a/18883819
export const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
  const R = 3959;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

export const generateRandomLocations = (n: number): MapLocation[] => {
  const randomBetween = (min: number, max: number) =>
    Math.random() * (max - min) + min;

  const names = [
    'Chicago & Chicago Suburbs, Cicero', 'Evanston', 'Oak Park', 'Skokie', 'Des Plaines',
    'Elmhurst', 'Melrose Park', 'Downers Grove', 'Hinsdale', 'Lombard'
  ];

  const generated: MapLocation[] = [];

  for (let i = 0; i < n; i++) {
    const lat = parseFloat(randomBetween(40.8, 42.8).toFixed(4));
    const lng = parseFloat(randomBetween(-89.9, -87.9).toFixed(4));

    const name = names[i % names.length] + (i >= names.length ? ` ${i}` : '');

    generated.push({
      id: i.toString(),
      name,
      coords: [lat, lng],
      address: {
        line1: `${100 + i} Example St`,
        line2: `${name}, IL 60000`
      },
      rating: {
        value: parseFloat(randomBetween(4.0, 5.0).toFixed(1)),
        reviewCount: Math.floor(randomBetween(30, 250))
      },
      href: `/locations/${name.toLowerCase().replace(/\s+/g, '-')}`
    });
  }

  return generated;
};